import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { apiRequest, getCurrentAuthToken } from '../api/client'
import { Button } from '../components/ui'
import { errorMessage, formatNumber } from '../utils/format'

interface CatalogResult {
  documentId: string
  documentStatus: string
  created: number
  reused: number
  existing: number
  skipped: number
}

export function ImportCatalogAction({ documentId }: { documentId: string }) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [result, setResult] = useState<CatalogResult | null>(null)
  const request = useRef<AbortController | null>(null)
  useEffect(() => () => request.current?.abort(), [])

  async function importCatalog() {
    const token = getCurrentAuthToken()
    if (!token || request.current) return
    const controller = new AbortController()
    request.current = controller
    setBusy(true)
    setError('')
    try {
      const response = await apiRequest<CatalogResult>(`/import/ppr/${documentId}/catalog`, {
        method: 'POST', body: {}, authToken: token, signal: controller.signal, timeout: 120_000,
      })
      if (controller.signal.aborted || getCurrentAuthToken() !== token) return
      setResult(response)
      window.dispatchEvent(new Event('amalthea:data-changed'))
    } catch (caught) {
      if (!controller.signal.aborted && getCurrentAuthToken() === token) setError(errorMessage(caught))
    } finally {
      request.current = null
      if (!controller.signal.aborted) setBusy(false)
    }
  }

  return <section className="surface">
    <div className="section-heading"><div><h3>Оборудование из ППР</h3><p>Перенесите распознанные позиции в реестр, чтобы проверить оборудование и подготовить программы ТО. Для создания месячного плана сначала подтвердите ППР.</p></div></div>
    <Button variant="secondary" loading={busy} onClick={() => void importCatalog()}>Заполнить реестр оборудования</Button>
    {result && <p className="mg-catalog-result" role="status">Добавлено: {formatNumber(result.created)}. Уже в реестре: {formatNumber(result.existing + result.reused)}. Строк для дополнительной проверки: {formatNumber(result.skipped)}. <Link className="text-link" to="/equipment">Открыть оборудование</Link></p>}
    {error && <div className="form-message form-message--error" role="alert">{error}</div>}
  </section>
}
